import { render } from "./Shrimp.vue?vue&type=template&id=eed4244c"
import script from "./Shrimp.vue?vue&type=script&lang=js"
export * from "./Shrimp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__